import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { attendanceDetail as _attendanceDetail, leaveDetail as _leaveDetail } from 'api/Attendance';
export default {
  data: function data() {
    return {
      visible: false,
      title: '',
      info: {},
      loading: false,
      table: {
        leave: [{
          prop: 'leave_type_name',
          label: this.$t('98'),
          // 请假类型
          width: 180,
          align: 'center'
        }, {
          prop: 'leave_start_time',
          label: this.$t('1536'),
          // 请假开始时间
          width: 180,
          align: 'center'
        }, {
          prop: 'leave_end_time',
          label: this.$t('1537'),
          // 请假结束时间
          width: 180,
          align: 'center'
        }, {
          prop: 'audit_reason',
          label: this.$t('remark'),
          // 备注
          width: '',
          align: 'center'
        }],
        attendance: [{
          prop: 'attendance_time',
          label: this.$t('1363'),
          width: 180,
          align: 'center'
        }, {
          prop: 'click_time',
          label: this.$t('1411'),
          width: 180,
          align: 'center'
        }, {
          prop: 'click_state_msg',
          label: this.$t('1412'),
          width: 180,
          align: 'center'
        }, {
          prop: 'address',
          label: this.$t('1413'),
          width: 180,
          align: 'center'
        }, {
          prop: 'remark',
          label: this.$t('1414'),
          width: 180,
          align: 'center'
        }, {
          prop: 'url',
          label: this.$t('1415'),
          width: 180,
          align: 'center'
        }]
      }
    };
  },
  methods: {
    init: function init(obj) {
      this.visible = true;
      var data = {
        staff_id: obj.staff_id,
        attendance_date: obj.attendance_date,
        attendance_category: obj.attendance_category
      };
      this.info.type = obj.type;
      if (obj.type === 'leave') {
        this.leaveDetail(data);
      } else {
        this.attendanceDetail(data);
      }
    },
    leaveDetail: function leaveDetail(obj) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.loading = true;
              _context.next = 3;
              return _leaveDetail(obj);
            case 3:
              res = _context.sent;
              _this.loading = false;
              _this.info = _objectSpread(_objectSpread({}, _this.info), {}, {
                title: res.data.title,
                group_name: res.data.group_name,
                data: _toConsumableArray(res.data.list)
              });
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    attendanceDetail: function attendanceDetail(obj) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.loading = true;
              _context2.next = 3;
              return _attendanceDetail(obj);
            case 3:
              res = _context2.sent;
              _this2.loading = false;
              _this2.info = _objectSpread(_objectSpread({}, _this2.info), {}, {
                title: res.data.title,
                group_name: res.data.group_name,
                data: [res.data]
              });
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};